module.exports = __webpack_public_path__ + "static/media/nitra.7eccab28.jpg";